<div class="custom-page-column">
  <!-- Page 1 -->
  <div class="font-small pdf-page app-cp-10-30-09-17" id="cp300917">
    <p class="font-small text-end">
      <b>COMMERCIAL PROPERTY<br />
        CP 10 30 09 17</b>
    </p>
    <p class="font-large" style="text-align: center">
      <b>CAUSES OF LOSS – SPECIAL FORM</b>
    </p>

    <p class="font-small">
      Words and phrases that appear in quotation marks have special meaning.
      Refer to Section G. Definitions.
    </p>
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Covered Causes Of Loss </b> <br />
                  When Special is shown in the Declarations, Covered Causes of
                  Loss means direct physical loss unless the loss is excluded or
                  limited in this policy.
                </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Exclusions</b>
                  <ol>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        We will not pay for loss or damage caused directly or
                        indirectly by any of the following. Such loss or damage is
                        excluded regardless of any other cause or event that
                        contributes concurrently or in any sequence to the loss.
                        <ol type="a">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              <b>Ordinance Or Law</b><br />
                              The enforcement of or compliance with any ordinance or
                              law:
                              <ol class="list-parentheses">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    Regulating the construction, use or repair of any
                                    property; or
                                  </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    Requiring the tearing down of any property,
                                    including the cost of removing its debris.
                                  </span>
                                </li>
                              </ol>
                              This exclusion, Ordinance Or Law, applies whether the
                              loss results from:
                              <ol class="list-parentheses type-lower-alpha">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    An ordinance or law that is enforced even if the
                                    property has not been damaged; or
                                  </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    The increased costs incurred to comply with an
                                    ordinance or law in the course of construction,
                                    repair, renovation, remodeling or demolition of
                                    property, or removal of its debris, following a
                                    physical loss to that property.
                                  </span>
                                </li>
                              </ol>
                            </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                              <b>Earth Movement </b><br />
                              <ol class="list-parentheses">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    Earthquake, including tremors and aftershocks and
                                    any earth sinking, rising or shifting related to
                                    such event;
                                  </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    Landslide, including any earth sinking, rising or
                                    shifting related to such event;
                                  </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                  <span style="font-weight: normal;">
                                    Mine subsidence, meaning subsidence of a man-made
                                    mine, whether or not mining activity has ceased;
                                  </span>
                                </li>
                              </ol>
                            </span>
                          </li>
                        </ol>
                      </span>
                    </li>
                  </ol>
                </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <ol start="4">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        Earth sinking (other than sinkhole collapse), rising or
                        shifting including soil conditions which cause settling,
                        cracking or other disarrangement of foundations or other
                        parts of realty. Soil conditions include contraction,
                        expansion, freezing, thawing, erosion, improperly compacted
                        soil and the action of water under the ground surface.
                      </span>
                    </li>
                  </ol>
                  <p>
                    But if Earth Movement, as described in
                    <b>b.(1)</b>
                    through
                    <b>(4)</b>
                    above, results in fire or explosion, we will pay for the loss
                    or damage caused by that fire or explosion.
                  </p>
                  <ol start="5">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        Volcanic eruption, explosion or effusion. But if volcanic
                        eruption, explosion or effusion results in fire, building
                        glass breakage or Volcanic Action, we will pay for the loss
                        or damage caused by that fire, building glass breakage or
                        Volcanic Action. Volcanic Action means direct loss or damage
                        resulting from the eruption of a volcano when the loss or
                        damage is caused by:
                        <ol type="a">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Airborne volcanic blast or airborne shock waves;</span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Ash, dust or particulate matter; or</span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Lava flow.</span>
                          </li>
                        </ol>
                        With respect to coverage for Volcanic Action as set forth in
                        (5)(a), (5)(b) and (5)(c), all volcanic eruptions that occur
                        within any 168-hour period will constitute a single
                        occurrence. <br />
                        Volcanic Action does not include the cost to remove ash,
                        dust or particulate matter that does not cause direct
                        physical loss or damage to the described property.
                      </span>
                    </li>
                  </ol>
                  <p>
                    This exclusion applies regardless of whether any of the above,
                    in Paragraphs
                    <b>(1)</b>
                    through
                    <b>(5)</b>, is caused by an act of nature or is otherwise
                    caused.
                  </p>
                </span>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 2 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol type="a" start="3">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Governmental Action</b><br />
                Seizure or destruction of property by order of governmental
                authority. <br />
                But we will pay for loss or damage caused by or resulting from
                acts of destruction ordered by governmental authority and taken
                at the time of a fire to prevent its spread, if the fire would
                be covered under this Coverage Part.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Nuclear Hazard </b><br />Nuclear reaction or radiation, or
                radioactive contamination, however caused. <br />
                But if nuclear reaction or radiation, or radioactive
                contamination, results in fire, we will pay for the loss or
                damage caused by that fire.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Utility Services </b><br />
                The failure of power, communication, water or other utility
                service supplied to the described premises, however caused, if
                the failure:
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Originates away from the described premises; or</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Originates at the described premises, but only if such
                    failure involves equipment used to supply the utility
                    service to the described premises from a source away from
                    the described premises
                  </span>
                  </li>
                </ol>
                Failure of any utility service includes lack of sufficient
                capacity and reduction in supply. <br />
                Loss or damage caused by a surge of power is also excluded, if
                the surge would not have occurred but for an event causing a
                failure of power. <br />
                But if the failure or surge of power, or the failure of
                communication, water or other utility service, results in a
                Covered Cause of Loss, we will pay for the loss or damage caused
                by that Covered Cause of Loss. <br />
                Communication services include but are not limited to service
                relating to Internet access or access to any electronic,
                cellular or satellite network.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>War And Military Action </b><br />
                (1) War, including undeclared or civil war;
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <ol start="2">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Warlike action by a military force, including action in
                    hindering or defending against an actual or expected attack,
                    by any government, sovereign or other authority using
                    military personnel or other agents; or
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Insurrection, rebellion, revolution, usurped power, or
                    action taken by governmental authority in hindering or
                    defending against any of these.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ul>
            <ol type="a" start="7">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Water</b><br />
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Flood, surface water, waves (including tidal wave and
                    tsunami), tides, tidal water, overflow of any body of water,
                    or spray from any of these, all whether or not driven by
                    wind (including storm surge);
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Mudslide or mudflow;</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Water that backs up or overflows or is otherwise discharged
                    from a sewer, drain, sump, sump pump or related equipment;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Water under the ground surface pressing on, or flowing or
                    seeping through:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Foundations, walls, floors or paved surfaces;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Basements, whether paved or not; or</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Doors, windows or other openings; or</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Waterborne material carried or otherwise moved by any of the
                    water referred to in Paragraph <b>(1), (3)</b> or
                    <b>(4),</b> or material carried or otherwise moved by
                    mudslide or mudflow.
                  </span>
                  </li>
                </ol>
                This exclusion applies regardless of whether any of the above,
                in Paragraphs
                <b>(1)</b> through <b>(5)</b>, is caused by an act of nature or
                is otherwise caused. An example of a situation to which this
                exclusion applies is the situation where a dam, levee, seawall
                or other boundary or containment system fails in whole or in
                part, for any reason, to contain the water.
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 3 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol>
              <li style="list-style-type: none">
                <ol start="7" type="a">
                  <li style="list-style-type: none">
                    But if any of the above, in Paragraphs <b> (1)</b> through
                    <b>(5),</b> results in fire, explosion or sprinkler leakage,
                    we will pay for the loss or damage caused by that fire,
                    explosion or sprinkler leakage (if sprinkler leakage is a
                    Covered Cause of Loss).
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    <b>"Fungus", Wet Rot, Dry Rot And Bacteria</b><br />
                    Presence, growth, proliferation, spread or any activity of
                    "fungus", wet or dry rot or bacteria. <br />
                    But if "fungus", wet or dry rot or bacteria result in a
                    "specified cause of loss", we will pay for the loss or
                    damage caused by that "specified cause of loss". <br />
                    This exclusion does not apply:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        When "fungus", wet or dry rot or bacteria result from
                        fire or lightning; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        To the extent that coverage is provided in the
                        Additional Coverage, Limited Coverage For "Fungus", Wet
                        Rot, Dry Rot And Bacteria, with respect to loss or
                        damage by a cause of loss other than fire or lightning.
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                </ol>
                Exclusions B.1.a. through B.1.h. apply whether or not the loss
                event results in widespread damage or affects a substantial
                area.
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                We will not pay for loss or damage caused by or resulting from
                any of the following:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Artificially generated electrical, magnetic or
                    electromagnetic energy that damages, disturbs, disrupts or
                    otherwise interferes with any:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Electrical or electronic wire, device, appliance, system
                        or network; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Device, appliance, system or network utilizing cellular
                        or satellite technology.
                      </span>
                      </li>
                    </ol>
                    For the purpose of this exclusion, electrical, magnetic or
                    electromagnetic energy includes but is not limited to:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Electrical current, including arcing;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Electrical charge produced or conducted by a magnetic or
                        electromagnetic field;
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Pulse of electromagnetic energy; or</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Electromagnetic waves or microwaves.</span>
                        </li>
                    </ol>
                    But if fire results, we will pay for the loss or damage
                    caused by that fire.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Delay, loss of use or loss of market.</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Smoke, vapor or gas from agricultural smudging or industrial
                    operations.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol type="a" start="4">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Wear and tear;</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Rust or other corrosion, decay, deterioration, hidden or
                    latent defect or any quality in property that causes it to
                    damage or destroy itself;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Smog;</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Settling, cracking, shrinking or expansion;</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Nesting or infestation, or discharge or release of waste
                    products or secretions, by insects, birds, rodents or other
                    animals.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Mechanical breakdown, including rupture or bursting caused
                    by centrifugal force. But if mechanical breakdown results in
                    elevator collision, we will pay for the loss or damage
                    caused by that elevator collision.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    The following causes of loss to personal property:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Dampness or dryness of atmosphere;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Changes in or extremes of temperature; or</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Marring or scratching.</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                </ol>
                But if an excluded cause of loss that is listed in
                <b>2.d.(1)</b> through <b>(7)</b> results in a "specified cause
                of loss" or building glass breakage, we will pay for the loss or
                damage caused by that "specified cause of loss" or building
                glass breakage.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Explosion of steam boilers, steam pipes, steam engines or steam
                turbines owned or leased by you, or operated under your control.
                But if explosion of steam boilers, steam pipes, steam engines or
                steam turbines results in fire or combustion explosion, we will
                pay for the loss or damage caused by that fire or combustion
                explosion. We will also pay for loss or damage caused by or
                resulting from the explosion of gases or fuel within the furnace
                of any fired vessel or within the flues or passages through
                which the gases of combustion pass.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Continuous or repeated seepage or leakage of water, or the
                presence or condensation of humidity, moisture or vapor, that
                occurs over a period of 14 days or more.
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 4 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol type="a" start="7">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Water, other liquids, powder or molten material that leaks or
                flows from plumbing, heating, air conditioning or other
                equipment (except fire protective systems) caused by or
                resulting from freezing, unless:
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    You do your best to maintain heat in the building or
                    structure; or
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    You drain the equipment and shut off the supply if the heat
                    is not maintained.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                . Dishonest or criminal act (including theft) by you, any of
                your partners, members, officers, managers, employees (including
                temporary employees and leased workers), directors, trustees or
                authorized representatives, whether acting alone or in collusion
                with each other or with any other party; or theft by any person
                to whom you entrust the property for any purpose, whether acting
                alone or in collusion with any other party. <br />
                This exclusion:
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Applies whether or not an act occurs during your normal
                    hours of operation;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Does not apply to acts of destruction by your employees
                    (including temporary employees and leased workers) or
                    authorized representatives; but theft by your employees
                    (including temporary employees and leased workers) or
                    authorized representatives is not covered.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Voluntary parting with any property by you or anyone else to
                whom you have entrusted the property if induced to do so by any
                fraudulent scheme, trick, device or false pretense.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Rain, snow, ice or sleet to personal property in the open.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                Collapse, including any of the following conditions of property
                or any part of the property:
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">An abrupt falling down or caving in;</span>
                        </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Loss of structural integrity, including separation of parts
                    of the property or property in danger of falling down or
                    caving in; or
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Any cracking, bulging, sagging, bending, leaning, settling,
                    shrinkage or expansion as such condition relates to
                    <b>(1)</b> or <b>(2)</b> above.
                  </span>
                  </li>
                </ol>
                But if collapse results in a Covered Cause of Loss at the
                described premises, we will pay for the loss or damage caused by
                that Covered Cause of Loss.
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol start="2">
              <li style="list-style-type: none">
                <ol start="11" type="a">
                  <li style="list-style-type: none">
                    This exclusion,<b> k.</b>, does not apply: <br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        To the extent that coverage is provided under the
                        Additional Coverage, Collapse; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        To collapse caused by one or more of the following:
                        <ol type="i">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">The "specified causes of loss";</span>
                        </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Breakage of building glass;</span>
                        </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Weight of rain that collects on a roof; or</span>
                        </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Weight of people or personal property</span>
                        </li>
                        </ol>
                      </span>
                      </li>
                    </ol>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Discharge, dispersal, seepage, migration, release or escape
                    of "pollutants" unless the discharge, dispersal, seepage,
                    migration, release or escape is itself caused by any of the
                    "specified causes of loss". But if the discharge, dispersal,
                    seepage, migration, release or escape of "pollutants"
                    results in a "specified cause of loss", we will pay for the
                    loss or damage caused by that "specified cause of loss".
                    <br />
                    This exclusion, I., does not apply to damage to glass caused
                    by chemicals applied to the glass.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Neglect of an insured to use all reasonable means to save
                    and preserve property from further damage at and after the
                    time of loss.
                  </span>
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                We will not pay for loss or damage caused by or resulting from
                any of the following, 3.a. through 3.c. But if an excluded cause
                of loss that is listed in 3.a. through 3.c. results in a Covered
                Cause of Loss, we will pay for the loss or damage caused by that
                Covered Cause of Loss.
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Weather conditions. But this exclusion only applies if
                    weather conditions contribute in any way with a cause or
                    event excluded in Paragraph <b>1</b>. above to produce the
                    loss or damage.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Acts or decisions, including the failure to act or decide,
                    of any person, group, organization or governmental body.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Faulty, inadequate or defective:
    
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Planning, zoning, development, surveying, siting;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Design, specifications, workmanship, repair,
                        construction, renovation, remodeling, grading,
                        compaction;
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Materials used in repair, construction, renovation or
                        remodeling; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Maintenance;</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 5 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol start="3">
              <li style="list-style-type: none">
                <ol>
                  <li style="list-style-type: none">
                    of part or all of any property on or off the described
                    premises.
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Special Exclusions </b><br />
                The following provisions apply only to the specified Coverage
                Forms:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    <b>Business Income (And Extra Expense) Coverage Form,
                      Business Income (Without Extra Expense) Coverage Form, Or
                      Extra Expense Coverage Form</b><br />
                    We will not pay for:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Any loss caused by or resulting from:
                        <ol type="a">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Damage or destruction of "finished stock"; or</span>
                        </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            The time required to reproduce "finished stock".
                          </span>
                          </li>
                        </ol>
                        This exclusion does not apply to Extra Expense
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Any loss caused by or resulting from direct physical
                        loss or damage to radio or television antennas
                        (including satellite dishes) and their lead-in wiring,
                        masts or towers.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Any increase of loss caused by or resulting from:
                        <ol type="a">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            Delay in rebuilding, repairing or replacing the
                            property or resuming "operations", due to
                            interference at the location of the rebuilding,
                            repair or replacement by strikers or other persons;
                            or
                          </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            Suspension, lapse or cancellation of any license,
                            lease or contract. But if the suspension, lapse or
                            cancellation is directly caused by the "suspension"
                            of "operations", we will cover such loss that
                            affects your Business Income during the "period of
                            restoration" and any extension of the "period of
                            restoration" in accordance with the terms of the
                            Extended Business Income Additional Coverage and the
                            Extended Period Of Indemnity Optional Coverage or
                            any variation of these.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Any Extra Expense caused by or resulting from
                        suspension, lapse or cancellation of any license, lease
                        or contract beyond the "period of restoration"
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Any other consequential loss.</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol start="2" type="a">
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Leasehold Interest Coverage Form</b><br />
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Paragraph <b>B.1.a.,</b> Ordinance Or Law, does not apply to
                    insurance under this Coverage Form
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    We will not pay for any loss caused by:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Your cancelling the lease;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        The suspension, lapse or cancellation of any license; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Any other consequential loss.</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Legal Liability Coverage Form </b><br />
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    The following exclusions do not apply to insurance under
                    this Coverage Form:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Paragraph <b>B.1.a.</b> Ordinance Or Law;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Paragraph <b>B.1.c.</b> Governmental Action;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Paragraph <b>B.1.d.</b> Nuclear Hazard;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Paragraph <b>B.1.e.</b> Utility Services; and</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Paragraph <b>B.1.f.</b> War And Military Action.</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    The following additional exclusions apply to insurance under
                    this Coverage Form:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        <b>Contractual Liability</b><br />
                        We will not defend any claim or "suit", or pay damages
                        that you are legally liable to pay, solely by reason of
                        your assumption of liability in a contract or agreement.
                        But this exclusion does not apply to a written lease
                        agreement in which you have assumed liability for
                        building damage resulting from an actual or attempted
                        burglary or robbery, provided that:
                        <ol type="i">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            Your assumption of liability was executed prior to
                            the accident; and
                          </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            The building is Covered Property under this Coverage
                            Form.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        <b>Nuclear Hazard</b><br />
                        We will not defend any claim or "suit", or pay any
                        damages, loss, expense or obligation, resulting from
                        nuclear reaction or radiation, or radioactive
                        contamination, however caused.
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 6 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol start="2" type="A">
              <li style="list-style-type: none">
                <ol start="5">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    <b>Additional Exclusion</b><br />
                    The following provisions apply only to the specified
                    property: <br />
                    <b>Loss Or Damage To Products</b> <br />
                    We will not pay for loss or damage to any merchandise, goods
                    or other product caused by or resulting from error or
                    omission by any person or entity (including those having
                    possession under an arrangement where work or a portion of
                    the work is outsourced) in any stage of the development,
                    production or use of the product, including planning,
                    testing, processing, packaging, installation, maintenance or
                    repair. This exclusion applies to any effect that
                    compromises the form, substance or quality of the product.
                    But if such error or omission results in a Covered Cause of
                    Loss, we will pay for the loss or damage caused by that
                    Covered Cause of Loss.
                  </span>
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                <b>Limitations</b><br />
                The following limitations apply to all policy forms and
                endorsements, unless otherwise stated:
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    We will not pay for loss of or damage to property, as
                    described and limited in this section. In addition, we will
                    not pay for any loss that is a consequence of loss or damage
                    as described and limited in this section.
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Steam boilers, steam pipes, steam engines or steam
                        turbines caused by or resulting from any condition or
                        event inside such equipment. But we will pay for loss of
                        or damage to such equipment caused by or resulting from
                        an explosion of gases or fuel within the furnace of any
                        fired vessel or within the flues or passages through
                        which the gases of combustion pass.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Hot water boilers or other water heating equipment
                        caused by or resulting from any condition or event
                        inside such boilers or equipment, other than an
                        explosion.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        The interior of any building or structure, or to
                        personal property in the building or structure, caused
                        by or resulting from rain, snow, sleet, ice, sand or
                        dust, whether driven by wind or not, unless:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            The building or structure first sustains damage by a
                            Covered Cause of Loss to its roof or walls through
                            which the rain, snow, sleet, ice, sand or dust
                            enters; or
                          </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                            The loss or damage is caused by or results from
                            thawing of snow, sleet or ice on the building or
                            structure.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol>
              <li style="list-style-type: none">
                <ol type="a" start="4">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Building materials and supplies not attached as part of the
                    building or structure, caused by or resulting from theft.
                    <br />
                    However, this limitation does not apply to:
    
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Building materials and supplies held for sale by you,
                        unless they are insured under the Builders Risk Coverage
                        Form; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Business Income Coverage or Extra Expense Coverage.
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Property that is missing, where the only evidence of the
                    loss or damage is a shortage disclosed on taking inventory,
                    or other instances where there is no physical evidence to
                    show what happened to the property.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Property that has been transferred to a person or to a place
                    outside the described premises on the basis of unauthorized
                    instructions.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Lawns, trees, shrubs or plants which are part of a vegetated
                    roof, caused by or resulting from:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        Dampness or dryness of atmosphere or of soil supporting
                        the vegetation;
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Changes in or extremes of temperature;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Disease;</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Frost or hail; or</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Rain, snow, ice or sleet.</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                We will not pay for loss of or damage to the following types of
                property unless caused by the "specified causes of loss" or
                building glass breakage:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Animals, and then only if they are killed or their
                    destruction is made necessary.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Fragile articles such as statuary, marbles, chinaware and
                    porcelains, if broken. This restriction does not apply to:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Glass; or</span>
                        </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">Containers of property held for sale</span>
                        </li>
                    </ol>
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                    Builders' machinery, tools and equipment owned by you or
                    entrusted to you, provided such property is Covered
                    Property. <br />
                    However, this limitation does not apply:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">
                        If the property is located on or within 100 feet of the
                        described premises, unless the premises is insured under
                        the Builders Risk Coverage Form; or
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 7 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol start="3" type="A">
              <li style="list-style-type: none">
                <ol start="2">
                  <li style="list-style-type: none">
                    <ol start="2">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        To Business Income Coverage or to Extra Expense
                        Coverage.
                      </span>
                      </li>
                    </ol>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The special limit shown for each category, a. through d., is
                    the total limit for loss of or damage to all property in
                    that category. The special limit applies to any one
                    occurrence of theft, regardless of the types or number of
                    articles that are lost or damaged in that occurrence. The
                    special limits are (unless a higher limit is shown in the
                    Declarations):
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        $2,500 for furs, fur garments and garments trimmed with
                        fur.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        $2,500 for jewelry, watches, watch movements, jewels,
                        pearls, precious and semiprecious stones, bullion, gold,
                        silver, platinum and other precious alloys or metals.
                        This limit does not apply to jewelry and watches worth
                        $100 or less per item.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">$2,500 for patterns, dies, molds and forms.</span>
                            </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        $250 for stamps, tickets, including lottery tickets held
                        for sale, and letters of credit.
                      </span>
                      </li>
                    </ol>
                    These special limits are part of, not in addition to, the
                    Limit of Insurance applicable to the Covered Property.
                    <br />
                    This limitation, <b>C.3.</b>, does not apply to Business
                    Income Coverage or to Extra Expense Coverage.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    We will not pay the cost to repair any defect to a system or
                    appliance from which water, other liquid, powder or molten
                    material escapes. But we will pay the cost to repair or
                    replace damaged parts of fire-extinguishing equipment if the
                    damage:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Results in discharge of any substance from an automatic
                        fire protection system; or
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Is directly caused by freezing.</span>
                            </li>
                    </ol>
                    However, this limitation does not apply to Business Income
                    Coverage or to Extra Expense Coverage.
                  </span>
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                <b>Additional Coverage – Collapse </b><br />
                The coverage provided under this Additional Coverage, Collapse,
                applies only to an abrupt collapse as described and limited in
                <b>D.1.</b> through <b>D.7.</b> <br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    For the purpose of this Additional Coverage, Collapse,
                    abrupt collapse means an abrupt falling down or caving in of
                    a building or any part of a building with the result that
                    the building or part of the building cannot be occupied for
                    its intended purpose.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol start="2">
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                We will pay for direct physical loss or damage to Covered
                Property, caused by abrupt collapse of a building or any part of
                a building that is insured under this Coverage Form or that
                contains Covered Property insured under this Coverage Form, if
                such collapse is caused by one or more of the following:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Building decay that is hidden from view, unless the presence
                    of such decay is known to an insured prior to collapse;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Insect or vermin damage that is hidden from view, unless the
                    presence of such damage is known to an insured prior to
                    collapse;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Use of defective material or methods in construction,
                    remodeling or renovation if the abrupt collapse occurs
                    during the course of the construction, remodeling or
                    renovation.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Use of defective material or methods in construction,
                    remodeling or renovation if the abrupt collapse occurs after
                    the construction, remodeling or renovation is complete, but
                    only if the collapse is caused in part by:
                    <ol class="list-parentheses">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        A cause of loss listed in <b>2.a.</b> or <b>2.b.</b>;
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">One or more of the "specified causes of loss";</span>
                            </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Breakage of building glass;</span>
                            </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Weight of people or personal property; or</span>
                            </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Weight of rain that collects on a roof.</span>
                            </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                This <b>Additional Coverage – Collapse</b> does not apply to:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    A building or any part of a building that is in danger of
                    falling down or caving in;
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    A part of a building that is standing, even if it has
                    separated from another part of the building; or
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    A building that is standing or any part of a building that
                    is standing, even if it shows evidence of cracking, bulging,
                    sagging, bending, leaning, settling, shrinkage or expansion
                  </span>
                  </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                With respect to the following property:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Outdoor radio or television antennas (including satellite
                    dishes) and their lead-in wiring, masts or towers;
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 8 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol start="4">
              <li style="list-style-type: none">
                <ol start="2" type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Awnings, gutters and downspouts;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Yard fixtures;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Outdoor swimming pools;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Fences;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Piers, wharves and docks;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Beach or diving platforms or appurtenances;</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Retaining walls; and</span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Walks, roadways and other paved surfaces;</span></li>
                </ol>
                if an abrupt collapse is caused by a cause of loss listed in
                <b>2.a.</b> through <b>2.d.,</b> we will pay for loss or damage
                to that property only if:
                <ol class="list-parentheses">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Such loss or damage is a direct result of the abrupt
                    collapse of a building insured under this Coverage Form; and
                  </span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The property is Covered Property under this Coverage Form.
                  </span></li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                If personal property abruptly falls down or caves in and such
                collapse is not the result of abrupt collapse of a building, we
                will pay for loss or damage to Covered Property caused by such
                collapse of personal property only if:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The collapse of personal property was caused by a cause of
                    loss listed in <b>2.a.</b> through <b>2.d.;</b>
                  </span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The personal property which collapses is inside a building;
                    and
                  </span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The property which collapses is not of a kind listed in
                    <b>4.,</b> regardless of whether that kind of property is
                    considered to be personal property or real property.
                  </span></li>
                </ol>
                The coverage stated in this Paragraph 5. does not apply to
                personal property if marring and/or scratching is the only
                damage to that personal property caused by the collapse
              </span></li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                This Additional Coverage, Collapse, does not apply to personal
                property that has not abruptly fallen down or caved in, even if
                the personal property shows evidence of cracking, bulging,
                sagging, bending, leaning, settling, shrinkage or expansion.
              </span></li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                This Additional Coverage, Collapse, will not increase the Limits
                of Insurance provided in this Coverage Part.
              </span></li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                The term Covered Cause of Loss includes the Additional Coverage,
                Collapse, as described and limited in <b>D.1.</b> through
                <b>D.7.</b>
              </span></li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol start="5" type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                <b>Additional Coverage – Limited Coverage For "Fungus", Wet Rot,
                  Dry Rot And Bacteria</b><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The coverage described in E.2. and E.6. only applies when
                    the "fungus", wet or dry rot or bacteria are the result of
                    one or more of the following causes that occur during the
                    policy period and only if all reasonable means were used to
                    save and preserve the property from further damage at the
                    time of and after that occurrence:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        A "specified cause of loss" other than fire or
                        lightning; or
                      </span></li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Flood, if the Flood Coverage Endorsement applies to the
                        affected premises.
                      </span></li>
                    </ol>
                    This Additional Coverage does not apply to lawns, trees,
                    shrubs or plants which are part of a vegetated roof.
                  </span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    We will pay for loss or damage by "fungus", wet or dry rot
                    or bacteria. As used in this Limited Coverage, the term loss
                    or damage means:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Direct physical loss or damage to Covered Property
                        caused by "fungus", wet or dry rot or bacteria,
                        including the cost of removal of the "fungus", wet or
                        dry rot or bacteria;
                      </span></li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        The cost to tear out and replace any part of the
                        building or other property as needed to gain access to
                        the "fungus", wet or dry rot or bacteria; and
                      </span></li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        The cost of testing performed after removal, repair,
                        replacement or restoration of the damaged property is
                        completed, provided there is a reason to believe that
                        "fungus", wet or dry rot or bacteria are present.
                      </span></li>
                    </ol>
                  </span></li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    The coverage described under E.2. of this Limited Coverage
                    is limited to $15,000. Regardless of the number of claims,
                    this limit is the most we will pay for the total of all loss
                    or damage arising out of all occurrences of "specified
                    causes of loss" (other than fire or lightning) and Flood
                    which take place in a 12- month period (starting with the
                    beginning of the present annual policy period). With respect
                    to a particular occurrence of loss which results in
                    "fungus", wet or dry rot or bacteria, we will not pay more
                    than a total of $15,000 even if the "fungus", wet or dry rot
                    or bacteria continue to be present or active, or recur, in a
                    later policy period.
                  </span></li>
                </ol>
              </span></li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 9 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol start="4">
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                The coverage provided under this Limited Coverage does not
                increase the applicable Limit of Insurance on any Covered
                Property. If a particular occurrence results in loss or damage
                by "fungus", wet or dry rot or bacteria, and other loss or
                damage, we will not pay more, for the total of all loss or
                damage, than the applicable Limit of Insurance on the affected
                Covered Property. <br />
                If there is covered loss or damage to Covered Property, not
                caused by "fungus", wet or dry rot or bacteria, loss payment
                will not be limited by the terms of this Limited Coverage,
                except to the extent that "fungus", wet or dry rot or bacteria
                cause an increase in the loss. Any such increase in the loss
                will be subject to the terms of this Limited Coverage.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                The terms of this Limited Coverage do not increase or reduce the
                coverage provided under Paragraph <b>F.2.</b> (Water Damage,
                Other Liquids, Powder Or Molten Material Damage) of this Causes
                Of Loss form or under the Additional Coverage, Collapse.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                The following, <b>6.a.</b> or <b>6.b.,</b> applies only if
                Business Income and/or Extra Expense Coverage applies to the
                described premises and only if the "suspension" of "operations"
                satisfies all terms and conditions of the applicable Business
                Income and/or Extra Expense Coverage Form:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    If the loss which resulted in "fungus", wet or dry rot or
                    bacteria does not in itself necessitate a "suspension" of
                    "operations", but such "suspension" is necessary due to loss
                    or damage to property caused by "fungus", wet or dry rot or
                    bacteria, then our payment under Business Income and/or
                    Extra Expense is limited to the amount of loss and/or
                    expense sustained in a period of not more than 30 days. The
                    days need not be consecutive.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    If a covered "suspension" of "operations" was caused by loss
                    or damage other than "fungus", wet or dry rot or bacteria
                    but remediation of "fungus", wet or dry rot or bacteria
                    prolongs the "period of restoration", we will pay for loss
                    and/or expense sustained during the delay (regardless of
                    when such a delay occurs during the "period of
                    restoration"), but such coverage is limited to 30 days. The
                    days need not be consecutive
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol start="6" type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                <b>Additional Coverage Extensions</b><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Property In Transit</b><br />
                    This Extension applies only to your personal property to
                    which this form applies.
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        You may extend the insurance provided by this Coverage
                        Part to apply to your personal property (other than
                        property in the care, custody or control of your
                        salespersons) in transit more than 100 feet from the
                        described premises. Property must be in or on a motor
                        vehicle you own, lease or operate while between points
                        in the coverage territory.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Loss or damage must be caused by or result from one of
                        the following causes of loss:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            Fire, lightning, explosion, windstorm or hail, riot
                            or civil commotion, or vandalism.
                          </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            Vehicle collision, upset or overturn. Collision
                            means accidental contact of your vehicle with
                            another vehicle or object. It does not mean your
                            vehicle's contact with the roadbed.
                          </span>
                          </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            Theft of an entire bale, case or package by forced
                            entry into a securely locked body or compartment of
                            the vehicle. There must be visible marks of the
                            forced entry.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        The most we will pay for loss or damage under this
                        Extension is $5,000.
                      </span>
                      </li>
                    </ol>
                    This Coverage Extension is additional insurance. The
                    Additional Condition, Coinsurance, does not apply to this
                    Extension.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Water Damage, Other Liquids, Powder Or Molten Material
                      Damage</b>
                    <br />
                    If loss or damage caused by or resulting from covered water
                    or other liquid, powder or molten material damage loss
                    occurs, we will also pay the cost to tear out and replace
                    any part of the building or structure to repair damage to
                    the system or appliance from which the water or other
                    substance escapes. This Coverage Extension does not increase
                    the Limit of Insurance.
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 10 -->
  <div class="font-small pdf-page app-cp-10-30-09-17">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol type="A" start="6">
              <li style="list-style-type: none">
                <ol start="3">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Glass</b><br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        We will pay for expenses incurred to put up temporary
                        plates or board up openings if repair or replacement of
                        damaged glass is delayed.
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        We will pay for expenses incurred to remove or replace
                        obstructions when repairing or replacing glass that is
                        part of a building. This does not include removing or
                        replacing window displays.
                      </span>
                      </li>
                    </ol>
                    This Coverage Extension <b>F.3.</b> does not increase the
                    Limit of Insurance.
                  </span>
                  </li>
                </ol>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                <b>Definitions</b><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    "Fungus" means any type or form of fungus, including mold or
                    mildew, and any mycotoxins, spores, scents or by-products
                    produced or released by fungi.
                  </span>
                  </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    "Specified causes of loss" means the following: fire;
                    lightning; explosion; windstorm or hail; smoke; aircraft or
                    vehicles; riot or civil commotion; vandalism; leakage from
                    fireextinguishing equipment; sinkhole collapse; volcanic
                    action; falling objects; weight of snow, ice or sleet; water
                    damage.
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Sinkhole collapse means the sudden sinking or collapse
                        of land into underground empty spaces created by the
                        action of water on limestone or dolomite. This cause of
                        loss does not include:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">The cost of filling sinkholes; or</span>
                            </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            Sinking or collapse of land into manmade underground
                            cavities.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Falling objects does not include loss or damage to:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">Personal property in the open; or</span>
                            </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            The interior of a building or structure, or property
                            inside a building or structure, unless the roof or
                            an outside wall of the building or structure is
                            first damaged by a falling object.
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                        Water damage means:
                        <ol class="list-parentheses">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                            Accidental discharge or leakage of water or steam as
                            the direct result of the breaking apart or cracking
                            of a plumbing, heating, air conditioning or other
                            system or appliance (other than a sump system
                            including its related equipment and parts), that is
                            located on the described premises and contains water
                            or steam; and
                          </span>
                          </li>
                        </ol>
                      </span>
                      </li>
                    </ol>
                  </span>
                  </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol>
              <li style="list-style-type: none">
                <ol start="2">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    Accidental discharge or leakage of water or waterborne
                    material as the direct result of the breaking apart or
                    cracking of a water or sewer pipe caused by wear and tear,
                    when the pipe is located off the described premises and is
                    connected to or is part of a potable water supply system or
                    sanitary sewer system operated by a public or private
                    utility service provider pursuant to authority granted by
                    the state or governmental subdivision where the described
                    premises are located.
                  </span>
                  </li>
                </ol>
                But water damage does not include loss or damage otherwise
                excluded under the terms of the Water Exclusion. Therefore, for
                example, there is no coverage under this policy in the situation
                in which discharge or leakage of water results from the breaking
                apart or cracking of a pipe which was caused by or related to
                weather-induced flooding, even if wear and tear contributed to
                the breakage or cracking. As another example, and also in
                accordance with the terms of the Water Exclusion, there is no
                coverage for loss or damage caused by or related to
                weather-induced flooding which follows or is exacerbated by pipe
                breakage or cracking attributable to wear and tear. <br />
                To the extent that accidental discharge or leakage of water
                falls within the criteria set forth in <b>c.(1)</b> or
                <b>c.(2)</b> of this definition of "specified causes of loss,"
                such water is not subject to the provisions of the Water
                Exclusion which preclude coverage for surface water or water
                under the surface of the ground.
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>